export default "__VITE_ASSET__c980f3f4__"